import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    createCashItemsBatchBodySchema,
    createCashItemsBatchResponseSchema,
    deleteCashItemsBodySchema,
    deleteCashItemsResponseSchema,
    listCashItemsQuerySchema,
    listCashItemsResponseSchema,
} from "@common/schemas/domains/cashItem/cashItem.schema";

const c = initContract();

export const cashItemContract = c.router(
    {
        createCashItems: {
            method: "POST",
            path: "/:workspaceId/batch",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            body: createCashItemsBatchBodySchema,
            responses: {
                200: createCashItemsBatchResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        listCashItems: {
            method: "GET",
            path: "/:workspaceId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            query: listCashItemsQuerySchema,
            responses: {
                200: listCashItemsResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteCashItems: {
            method: "POST",
            path: "/:workspaceId/delete",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            body: deleteCashItemsBodySchema,
            responses: {
                200: deleteCashItemsResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/cash-items",
    },
);
